import { render, staticRenderFns } from "./DesignerList.vue?vue&type=template&id=58c11a3a&scoped=true"
import script from "./DesignerList.vue?vue&type=script&lang=js"
export * from "./DesignerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c11a3a",
  null
  
)

export default component.exports